import styled from 'styled-components'

export const IntroDiv = styled.div`
    height: 90vh;
    width: 100%;

    display: flex;
    justify-content: space-evenly;
    align-items: center;
    flex-direction: column;

    color: #fff;
    font-size: 4.8rem;
    font-weight: 200;

    .icon {
        fill: #fff;
        width: 25px;
        height: 25px;
    }
`

export const ContentDiv = styled.div`
    transform: scaleX(${props => props.scale});
    width: 100%;
    background-color: #fff;
    border-radius: 3px;

    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
`